<template>
    <div class="container"  v-title="'我的认证赛事'">
        <Navigation-bar :class="{'Bokeh':certificateShow}"></Navigation-bar>
        <div class="container_content" :class="{'Bokeh':certificateShow}">
            <Title title="我的认证赛事" subtitle="查看进度及赛事评定结果"></Title>
            <div id="MyEventCertification">
                <div class="MEC_scroll">
                    <Pull-refresh 
                        v-model="PullRefresh.loading" 
                        loosing-text="释放刷新数据"
                        loading-text="正在刷新数据..." 
                        :success-text="PullRefresh.text" 
                        @refresh="onRefresh"
                    >
                        <div class="MEC_content">
                            <div class="regulation">
                                <div class="whole" v-show="regulation" v-href="'/Rules/CertificationRegulation'">
                                    <p>「中企体协赛事管理办法」</p>
                                    <p>赛事认证·赛事积分·运动员等级评定</p>
                                    <p><span>点击进入</span><YD-image src="logo_新"></YD-image></p>
                                </div>
                                <div class="simplify" v-show="!regulation" v-href="'/Rules/CertificationRegulation'">
                                    <div>
                                        <span>「中企体协赛事管理办法」</span><span>点击进入</span>
                                    </div>
                                </div>
                            </div>
                            <div class="cover" v-show="!regulation"></div>
                            <ul>
                                <template v-for="({
                                        CompanyLeagueId,
                                        MainLeagueId,
                                        LeagueSerialId,
                                        LeagueSerialName,
                                        AuditStatus,
                                        League,
                                        SeasonType,
                                        CurrentCertificate
                                    },index) in list">

                                    <li class="item" :key="index" v-if="!LeagueSerialId">
                                        <div class="item_header">
                                            <div class="match_name">
                                                <span>{{ellipsis(League.Name)}}</span>
                                            </div>
                                            <div class="state">
                                                <span v-if="AuditStatus.Status == 10">初审中</span>
                                                <span v-else-if="AuditStatus.Status == 11">初审通过</span>
                                                <span v-else-if="AuditStatus.Status == 12" class="no">初审未通过</span>
                                                <span v-else-if="AuditStatus.Status == 20">{{SeasonType == 2 ? '复审通过' : '初审通过'}}</span>
                                                <span v-else-if="AuditStatus.Status == 21">复审中</span>
                                                <span v-else-if="AuditStatus.Status == 22">复审通过</span>
                                                <span v-else-if="AuditStatus.Status == 23" class="no">复审未通过</span>
                                            </div>
                                            <template v-if="SeasonType != 2">
                                                <div class="hint" v-if="[11, 20, 21, 23].includes(AuditStatus.Status)">初审评定为{{CurrentCertificate.Level}}级赛事</div>
                                                <div class="hint" v-else-if="AuditStatus.Status == 22">{{CurrentCertificate.Level}}级赛事已认证</div>
                                            </template>
                                            <template v-else>
                                                <div class="hint" v-if="[20, 21, 22, 23].includes(AuditStatus.Status)">{{CurrentCertificate.Level}}级赛事已认证</div>
                                            </template>
                                        </div>
                                        <div class="item_content">
                                            <h5>赛事全称：</h5>
                                            <p>{{League.Name}}</p>
                                        </div>
                                        <div class="item_footer">
                                            <button v-if="[12, 23].includes(AuditStatus.Status)" @click="lookReason(AuditStatus.RejectReason)">查看原因</button>
                                            <button v-if="AuditStatus.Status == 22" v-href="`/Competition/PastRecords/${MainLeagueId}`">历史认证</button>
                                            <button v-if="AuditStatus.Status == 22" @click="lookOverCertificate(CurrentCertificate.CertificateNumber)">查看证书</button>
                                            <button class="sign" v-if="AuditStatus.Status == 12" v-href="`/Competition/EventCertification/${CompanyLeagueId}`">修改资料</button>
                                            <button class="sign" v-if="[11, 20, 21, 22, 23].includes(AuditStatus.Status)" @click="managementPlatform()">
                                                <span>举办比赛</span>
                                                <div class="bubble">当前赛事可举办比赛</div>
                                            </button>
                                            <button class="sign disabled" v-else>举办比赛</button>
                                        </div>
                                    </li>

                                    <li class="item" :key="index" v-else>
                                        <div class="item_header">
                                            <div class="match_name">
                                                <span>{{ellipsis(League.Name)}}</span>
                                            </div>
                                            <div class="state">
                                                <span v-if="AuditStatus.Status == 10">申办资料审核中</span>
                                                <span v-else-if="[11, 20].includes(AuditStatus.Status)">申办资料审核通过</span>
                                                <span v-else-if="AuditStatus.Status == 12" class="no">申办资料审核未通过</span>
                                                <span v-else-if="AuditStatus.Status == 21">完赛资料审核中</span>
                                                <span v-else-if="AuditStatus.Status == 23" class="no">完赛资料审核未通过</span>
                                                <span v-else-if="AuditStatus.Status == 22">完赛资料审核通过</span>
                                            </div>
                                            <div class="hint" v-if="[11, 20].includes(AuditStatus.Status)">申办资料审核通过，请按计划办赛</div>
                                        </div>
                                        <div class="item_content">
                                            <h5>赛事全称：</h5>
                                            <p>{{LeagueSerialName}} - {{League.Name}}</p>
                                        </div>
                                        <div class="item_footer">
                                            <button v-if="[12, 23].includes(AuditStatus.Status)" @click="lookReason(AuditStatus.RejectReason)">查看原因</button>
                                            <button style="width: 2.42rem" v-if="[11, 20].includes(AuditStatus.Status)" v-href="`/Competition/BidEvent?serialId=${LeagueSerialId}&leagueId=${MainLeagueId}&from=my&step=last`">提交完赛资料</button>
                                            <button class="sign" v-if="AuditStatus.Status == 12" v-href="`/Competition/BidEvent?serialId=${LeagueSerialId}&leagueId=${CompanyLeagueId}&from=my&step=first`">修改资料</button>
                                            <button class="sign" v-if="AuditStatus.Status == 23" v-href="`/Competition/BidEvent?serialId=${LeagueSerialId}&leagueId=${MainLeagueId}&from=my&step=last`">修改资料</button>
                                            <button class="sign" v-if="[11, 20].includes(AuditStatus.Status)" @click="managementPlatform()">
                                                <span>举办比赛</span>
                                                <div class="bubble">当前赛事可举办比赛</div>
                                            </button>
                                            <button class="sign disabled" v-else>举办比赛</button>
                                        </div>
                                    </li>

                                </template>
                            </ul>
                            <div class="operation">
                                <button @click="apply()">申请认证</button>
                            </div>
                        </div>
                    </Pull-refresh>
                </div>
                
            </div>
        </div>
        <div id="certificate" v-show="certificateShow" ref="certificate">
            <div class="certificate_modal share">
                <YD-image class="certificate_close" src="icon/icon_close" @click.native="certificateShow = false"></YD-image>
                <div class="certificate_content" v-certificateScale>
                    <YD-image class="medal" :src="'certificate/icon_证书_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="competition_name">
                        <div class="competition_name-content">
                            <p v-for="item in LeagueNames" :key="item">{{item}}</p>
                        </div>
                    </div>
                    <YD-image class="grade" :src="'certificate/文字_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="certificate_serialNumber">证书编号：{{certificateInfo.CertificateNumber}}</div>
                    <div class="certificate_date">{{certificateInfo.IssueDate | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
                <!-- 低版本兼容-->
                <template v-if="$appVersion < '22093000'">
                    <p>请拨打电话4006240066联系客服邮寄证书</p>
                    <button class="certificate_share" @click="download()">保存</button>
                </template>
                <template v-else>
                    <p><span @click="makingCalls">拨打电话</span>联系客服邮寄证书</p>
                    <button class="certificate_share" @click="share">分享</button>
                </template>
            </div>
        </div>
        <div id="management_system_info" v-show="MSInfoShow" @click="closeModel('MSInfoShow')">
            <div class="content" >
                <h4>请前往中企赛事管理平台创办比赛</h4>
                <p><span>网&emsp;址：</span><span>{{MSInfo.url}}</span></p>
                <p><span>用户名：</span><span>{{MSInfo.userName}}</span></p>
                <p><span>密&emsp;码：</span><span>{{MSInfo.password}}</span></p>
                <button class="copy" @click="copy()">复制</button>
                <YD-image class="close" src="icon/icon_dialog_close" @click.native="closeModel('MSInfoShow')"></YD-image>
            </div>
        </div>
        <div id="flow_chart" v-show="flowChartShow" @click="closeModel('flowChartShow')">
            <div class="content" >
                <h4>认证流程指引</h4>
                <ul>
                    <li>
                        <p><span>提交初审资料</span><YD-image src="icon/认证流程指引_标签_用户"></YD-image></p>
                        <p>比赛开始前，填写并提交赛事真实信息及资料</p>
                        <YD-image class="num" src="icon/认证流程指引_序号一"></YD-image>
                    </li>
                    <li>
                        <p><span>初审级别评定</span><YD-image src="icon/认证流程指引_标签_平台"></YD-image></p>
                        <p>根据您填写及提交的信息依照赛事管理办法进行初审评定级别</p>
                    </li>
                    <li>
                        <p><span>提交复审资料</span><YD-image src="icon/认证流程指引_标签_用户"></YD-image></p>
                        <p>比赛结束后，提交比赛相关的真实资料进行复审</p>
                        <YD-image class="num" src="icon/认证流程指引_序号二"></YD-image>
                    </li>
                    <li>
                        <p><span>复审定级发证</span><YD-image src="icon/认证流程指引_标签_平台"></YD-image></p>
                        <p>根据初审及复审资料依照赛事管理办法进行赛事级别评定</p>
                    </li>
                </ul>
                <button v-href="'/Competition/EventCertification'">我知道了</button>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import tools from '@/common/tools';
import operate from '@/common/operate';
import appInteraction from "@/common/appInteraction";
export default {
    name:"MyEventCertification",
    components:{
        PullRefresh
    },
    data(){
        return {
            regulation: true,//管理方法显示样式
            roll: 0,//滚动距离
            list:[],
            certificateInfo:{},//证书信息
            certificateShow:false,//证书显示
            MSInfo:{//管理平台信息显
                url:process.env.VUE_APP_WEB_URL,
                userName:'',
                password:''
            },
            MSInfoShow: false,
            PullRefresh:{
                loading:false,
                text:''
            },
            flowChartShow:false
        }
    },
    created(){
        this.getList();
    },
    mounted(){
        var _this = this;
        $('#MyEventCertification .MEC_scroll').scroll(function () {
            var scroll = $('#MyEventCertification .MEC_scroll').scrollTop();
            _this.roll = scroll;
        });
        var h = document.body.offsetHeight;
        if(tools.remToPx(134) > h){
            this.$refs['certificate'].style.alignItems = "normal";
        }
    },
    watch:{
        roll:function(scroll){
            $('#MyEventCertification .MEC_scroll').scrollTop(this.roll);
            var wholeH =  $('#MyEventCertification .regulation').height(),
                simplifyH = $('#MyEventCertification .regulation .simplify').height();
            //管理办法
            if(scroll > wholeH - simplifyH){
                this.regulation = false;
            }else{
                this.regulation = true;
            }
        },
    },
    computed: {
        LeagueNames(){
            let {
                LeagueNameByLines,
                LeagueName
            } = this.certificateInfo;
            if(LeagueNameByLines){
                return LeagueNameByLines.split(',');
            }
            return [LeagueName];
        }
    },
    methods:{
        ellipsis(text){
            return text.length > 11 ? tools.ellipsis(text, 11) : text;
        },
        getList(){
            this.$api.GetMyAuditLeagueList().then(data=>{
                this.PullRefresh.loading = false;
                if(data.Code == 0){
                    this.list = data.MyAuditLeagueList;
                    this.PullRefresh.text = '数据刷新成功';
                    if(data.LeagueManageAccount){
                        this.MSInfo.userName = data.LeagueManageAccount.LoginName;
                        this.MSInfo.password = data.LeagueManageAccount.Password;
                    }
                }else{
                    this.PullRefresh.text = '数据刷新失败';
                }
            }).catch(()=>{
                this.PullRefresh.loading = false;
                this.PullRefresh.text = '数据刷新失败';
            })
        },
        lookReason(reason){
            this.$Prompt({
                title: '未通过原因',
                message: reason,
                confirmText: '知道了'
            })
        },
        lookOverCertificate(CertificateNumber){
            if(!CertificateNumber)return;
            this.$api.GetLeagueCertificate({
                CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    this.certificateInfo = data.LeagueCertificate;
                    this.certificateShow = true;
                }
            })
        },
        download(){
            this.$api.GetMyLeagueCertificateFile({
                CertificateNumber:this.certificateInfo.CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    appInteraction.saveImage(data.CertificateFile);
                }
            })
        },
        //分享
        share(){
            this.$api.GetMyLeagueCertificateFile({
                CertificateNumber: this.certificateInfo.CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    appInteraction.share({
                        Type: 6,
                        Title: "",
                        Text: "",
                        Link: "https://m.dazhongyundong.com/app_download/",
                        LinkText: "立即下载APP：",
                        ImgLink: data.CertificateFile
                    });
                }
            })
        },
        //拨打电话
        makingCalls(){
            appInteraction.makingCalls('4006240066');
        },
        //复制
        copy(){
            operate.copy(`请前往中企赛事管理平台创办比赛\n网  址：${this.MSInfo.url}\n用户名：${this.MSInfo.userName}\n密  码：${this.MSInfo.password}`).then(()=>{
                this.$Toast('复制成功');
            });
        },
        managementPlatform(){
            $('#management_system_info .content').removeClass('in').addClass('out');
            this.MSInfoShow = true;
        },
        apply(){
            $('#flow_chart .content').removeClass('in').addClass('out');
            this.flowChartShow = true;
        },
        closeModel(type){
            if(type == 'MSInfoShow'){
                $('#management_system_info .content').removeClass('out').addClass('in');
            }else{
                $('#flow_chart .content').removeClass('out').addClass('in');
            }
            setTimeout(() => {
                this[type] = false;
            }, 300);
        },
        onRefresh(){
            this.getList();
        }
    }
}
</script>
<style lang="scss" scoped>
.disabled{
    filter: opacity(0.5);
}
#MyEventCertification{
    position: relative;
    overflow: hidden;
    .MEC_scroll{
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        .MEC_content{
            width: 100%;
            height: auto;
        }
    }
    @include regulation;
    .cover{
        width: 100%;
        height: 40px;
        background: #fff;
        position:absolute;
        top: 64px;
        left: 0;
        z-index: 2;
    }
    ul{
        padding: 0 40px;
        padding-top: 40px;
    }
    ul>li{
        width: 100%;
        height: 360px;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-bottom: 20px;
        padding: 0 26px;
        box-sizing: border-box;
        .item_header{
            height: 120px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px #F0F0F0 solid;
            position: relative;
            &.border-none{
                border-bottom: none; 
            }
            .match_name{
                padding-right: 10px;
                span{
                        font-family: PingFangSC-Medium;
                    font-size: 28px;
                    color: #1B1C1E;
                    letter-spacing: 0;
                    font-weight: 500;
                }
            }
            .state{
                flex: none;
                span{
                    font-family: PingFangSC-Regular;
                    font-size: 28px;
                    color: #7E7E7F;
                    text-align: right;
                    font-weight: 400;
                    &.no{
                        color: #F06E43;
                    }
                }
            }
            .hint{
                font-family: PingFangSC-Regular;
                font-size: 24px;
                color: #FFA61C;
                letter-spacing: 0;
                font-weight: 400;
                line-height: 34px;
                position: absolute;
                left: 0;
                top: 82px;
            }
        }
        .item_content{
            width: 100%;
            margin-top: 11px;
            h5{
                font-family: PingFangSC-Medium;
                font-size: 28px;
                color: #3B3B3B;
                font-weight: 500;
                line-height: 40px;
                margin-bottom: 8px;
            }
            p{
                height: 80px;
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #7E7E7F;
                font-weight: 400;
                line-height: 40px;
                @include ellipsis(2);
            }
        }
        .item_footer{
            width: 100%;
            height: 64px;
            margin-top: 4px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            button{
                width: 196px;
                height: 64px;
                border: 2px solid #E9E9E9;
                border-radius: 33px;
                box-sizing: border-box;
                margin-right: 14px;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFangSC-Medium;
                font-size: 28px;
                color: #404349;
                letter-spacing: 0;
                font-weight: 500;
                &:last-of-type{
                    margin-right: 0;
                }
                &.sign{
                    background: #1B1C1E;
                    border: none;
                    color: #FFFFFF;
                }
                .bubble{
                    width: 282px;
                    height: 98px;
                    box-sizing: border-box;
                    padding-top: 12px;
                    @include bg-image("~@images/match_detail/my_bubble_hint");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    position: absolute;
                    top: 48px;
                    right: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-family: PingFangSC-Medium;
                    font-size: 24px;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }
        }
    }
    .operation{
        width: 100%;
        margin-top: 120px;
        margin-bottom: 76px;
        button{
            width: 670px;
            @include line-height(92px);
            background: #F5F7F5;
            border-radius: 20px;
            font-size: 32px;
            color: #1B1C1E;
            letter-spacing: 6px;
            text-align: center;
            font-weight: 500;
            display: block;
            margin: 0 auto;
        }
    }
}
@include certificate;
#management_system_info{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.40);
    z-index: 2;
    .content{
        height: 478px;
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px -36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 40px 40px 0px 0px;
        position: absolute;
        bottom: 0;
        left: 0;
        padding-top: 48px;
        box-sizing: border-box;
        &.out{
            transform: translateY(0%);
            animation: content-out 0.3s linear;
        }
        &.in{
            transform: translateY(100%);
            animation: content-in 0.3s linear;
        }
        h4{
            @include line-height(44px);
            padding-left: 56px;
            font-size: 32px;
            color: #FFA61C;
            font-weight: 500;
            margin-bottom: 40px;
        }
        p{
            @include line-height(44px);
            padding-left: 56px;
            font-size: 28px;
            color: #3A3F49;
            line-height: 44px;
            font-weight: 400;
            margin-bottom: 24px;
            span:nth-of-type(1){
                color: #8B8C8D;
                margin-right: 24px;
            }
        }
        button{
            width: 100%;
            @include line-height(94px);
            font-size: 32px;
            color: #1B1C1E;
            letter-spacing: 6px;
            text-align: center;
            font-weight: 500;
            border-top: 1px solid #DEDEDE;
            box-sizing: border-box;
            margin-top: 48px;
        }
        .close{
            width: 48px;
            height: 48px;
            position: absolute;
            top:32px ;
            right: 32px;
        }
    }
}
#flow_chart{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.40);
    z-index: 2;
    .content{
        height: auto;
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px -36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 40px 40px 0px 0px;
        position: absolute;
        bottom: 0;
        left: 0;
        padding-top: 48px;
        box-sizing: border-box;
        &.out{
            transform: translateY(0%);
            animation: content-out 0.3s linear;
        }
        &.in{
            transform: translateY(100%);
            animation: content-in 0.3s linear;
        }
        h4{
            @include line-height(44px);
            padding-left: 40px;
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
            margin-bottom: 56px;
        }
        ul{
            overflow-y: auto;
            li{
                width: 100%;
                padding: 0 40px 0 104px;
                box-sizing: border-box;
                margin-bottom: 56px;
                position: relative;
                p:nth-of-type(1){
                    height: 40px;
                    width: 100%;
                    font-size: 32px;
                    color: #1B1C1E;
                    line-height: 40px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    img{
                        width: 72px;
                        height: 34px;
                        margin-left: 8px;
                    }
                }
                p:nth-of-type(2){
                    font-size: 26px;
                    color: #4D5561;
                    line-height: 44px;
                    font-weight: 400;
                    margin-top: 16px;
                }
                >img{
                    height: 56px;
                    width: 56px;
                    position: absolute;
                    top: 0;
                    left: 28px;
                }
            }
        }
        button{
            width: 296px;
            @include line-height(108px);
            background: #1B1C1E;
            box-shadow: 0px 10px 20px 0px rgba(27,28,30,0.25);
            border-radius: 54px;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 6px;
            font-weight: 500;
            display: block;
            margin: 0 auto;
            margin-top: 24px;
            margin-bottom: 30px;
        }
    }
}
@keyframes content-out{
    0%{
        transform: translateY(100%);
    }
    100%{
        transform: translateY(0%);
    }
}
@keyframes content-in{
    0%{
        transform: translateY(0%);
    }
    100%{
        transform: translateY(100%);
    }
}
</style>